<template>

  <NdsDlg
      v-if="selectedApplic"
      :isOpen.sync="isNdsDlgOpen"
      :application="selectedApplic"
      @update:isOpen="val => {
      isNdsDlgOpen = val;
      if (!val) selectedApplic = null;
    }"
  />

  <v-chip class="statusInfo" v-bind:style="statusStyle">
    <div class="header">
      <span class="headerName">{{ name }}</span>
      <v-icon v-if="isSupplier && code === procedureStep.COMPLETED && result?.isCurrentContragentWinner">
        custom:winnerCup
      </v-icon>
    </div>
    <div class="statusInfoDate" v-if="date">{{ date }}</div>
    <div class="winnerInfo" v-if="isSupplier && code === procedureStep.COMPLETED && result?.isWinner">
      <div class="winnerInfoDescription">
        {{ $t(result?.isCurrentContragentWinner ? 'Вы являетесь победителем!' : 'Победил другой участник') }}
      </div>
      <span
        v-if="result?.isCurrentContragentWinner"
        :style="{ cursor: result?.ndsValue ? 'pointer' : 'default' }"
        @click="result?.ndsValue ? openDialog(result) : null"
      >
        <div class="winnerInfoTotalAmount">
          {{ $t('Сумма заказа:') }} {{ filters.formatPrice(result?.ndsValue ? result.winnerOfferPriceWithNds : result.winnerOfferPrice, result?.isNds) }}
        </div>
      </span>
    </div>
  </v-chip>
</template>

<script>
import {formatMoneyText, formatPrice} from "@/filters";
import Config from '@/config';
import procedureStep from "@/components/ProcedureStep";
import {calcPriceNdsByPrice} from "@/lib/nds";
import NdsDlg from "@/components/application/dialogs/NdsDlg.vue";

  export default {
    name: 'StatusInfo',
    components: {NdsDlg},
    props: {
      name: {
        type: String,
        required: true
      },
      code: {
        type: String,
        required: true
      },
      result: {
        type: Object,
        required: false
      },
      date: {
        type: String
      },
      statusStyle: {
        required: true
      }
    },

    data() {
      return {
        procedureStep,
        isSupplier: Config.getUser().hasRole('ROLE_SUPPLIER'),
        filters: {
          formatPrice: formatMoneyText,
          ndsPrice: calcPriceNdsByPrice
        },
        selectedApplic: null,
        isNdsDlgOpen: false
      };
    },
    methods: {
      openDialog(result) {
        this.selectedApplic = {
          offerPrice: result.offerPrice,
          nds: {
            rate: result.ndsValue
          },
          positions: result.positions,
        };
        this.isNdsDlgOpen = true;
      }
    }
  };
</script>

<style scoped lang="scss">
  .statusInfo {
    height: fit-content;
    border-radius: 10px;
    padding: 14px 18px;

    cursor: default;
    font-weight: 500;
    font-size: 16px;
    font-family: var(--primary-font-family-name);

    .header {
      width: 100%;
      display: flex;
      justify-content: space-between;

      &Name {
        font-weight: 600;
        font-size: 20px;
      }
    }

    &Date {
      font-weight: 400;
    }

    .winnerInfo {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;

      &Description, &TotalAmount {
        font-weight: 500;
      }
    }
  }

  :deep(.v-chip__content) {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
</style>
